import { render, staticRenderFns } from "./EHelpInformative.vue?vue&type=template&id=229831ed"
import script from "./EHelpInformative.vue?vue&type=script&lang=js"
export * from "./EHelpInformative.vue?vue&type=script&lang=js"
import style0 from "./EHelpInformative.vue?vue&type=style&index=0&id=229831ed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports